/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * ApiKeyModal
 *
 */

import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalHeader,
  Button,
} from '@cashfree-intl/coherent';

import { copyToClipboard } from 'utils/common';
import Analytics from 'utils/analytics';
import EVENTS from '../../constants/analytics';

import CustomIcon from '../CustomIcons';

function ApiKeyModal({
  open,
  isViewMode = false,
  closeModal,
  data,
  downloadClick,
}) {
  const [isLoading, resetLoadingFlag] = useState(false);

  const downloadAPIKeyFnClick = e => {
    downloadClick();
    Analytics.trackEventWithNewNomenclature({
      eventName: 'Primary_Button_Download_API_Key',
    });
    e.stopPropagation();
  };

  useEffect(() => {
    if (!!data && Object.keys(data).length > 0 && isLoading)
      resetLoadingFlag(false);
  }, [data]);

  return (
    <Modal open={open} className="common-modal-wrapper api-key-modal">
      <ModalHeader>
        <div>
          <div className="heading">
            {isViewMode ? 'API Keys' : 'New API Keys'}
          </div>
        </div>
        <div
          className="close-modal"
          onClick={closeModal}
          data-event-name="Form_ApiKeyModal_Icon_Close"
          data-ignore-inner-text="true"
        >
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <ModalContent>
        <div className="modal-content">
          <div className="message">
            <CustomIcon componentName="EXCLAMAITON" />
            <span className="mt-1">
              Download the API keys and keep it safe.
            </span>
          </div>
          <div className="fields-wrapper">
            <div className="field">
              <label htmlFor="API_Key_app_id">AppID</label>
              {!!data && (
                <>
                  <span id="API_Key_app_id">{data.appId}</span>
                  <CustomIcon
                    componentName="COPY_TO_CLIPBOARD"
                    handleClick={() => {
                      Analytics.track(EVENTS.API_KEYS.APP_ID_COPY);
                      copyToClipboard(data.appId)();
                    }}
                  />
                </>
              )}
            </div>
            <div className="field">
              <label htmlFor="API_Key_secret_key">Secret Key</label>
              {!!data && (
                <>
                  <span id="API_Key_secret_key">{data.secretKey}</span>
                  <CustomIcon
                    componentName="COPY_TO_CLIPBOARD"
                    handleClick={() => {
                      Analytics.track(EVENTS.API_KEYS.SECRET_KEY_COPY);
                      copyToClipboard(data.secretKey)();
                    }}
                  />
                </>
              )}
            </div>
          </div>
          <div className="cta-wrapper">
            <Button
              link
              className="link"
              type="button"
              onClick={closeModal}
              data-event-name="Form_ApiKeyModal_Button_Cancel"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="download-csv-button"
              primary
              onClick={downloadAPIKeyFnClick}
              data-event-name="Primary_Button_Download_API_Key"
            >
              Download API Key
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
}

ApiKeyModal.propTypes = {
  open: PropTypes.bool.isRequired,
  isViewMode: PropTypes.bool,
  data: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  downloadClick: PropTypes.func.isRequired,
};

export default memo(ApiKeyModal);
